const list = {
  path: 'cooperation',
  component: resolve => require(['@/pages/admin/platform/cooperation'], resolve)
}

export default list
